export default __webpack_public_path__ + "static/media/16-1.533a566f.mp3";